"use strict";
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

angular.module('app.filters')

    .filter('numeric', ['$filter', function($filter) {
        return function(value, format, decimals) {
            switch (format) {
                case $.globals.format.decimal:
                    return $filter('number')(value, decimals);

                case $.globals.format.percentage:
                    return $filter('number')(value * 100, decimals) + '%';

                case $.globals.format.currency:
                    return '$' + $filter('number')(value, decimals);

                default: //$.globals.format.numeric
                    return $filter('number')(value, 0);
            }
        };
    }])
    .filter('minutesToTime', ['$filter', function($filter) {
        return function(value) {
            var hours = Math.floor(value / 60);
            var minutes = value % 60;
            if (minutes < 10) {
                return hours + ":0" + minutes;
            } else {
                return hours + ":" + minutes;
            }

        };
    }])
    .filter('customTaskFilter', ['$rootScope', function($rootScope) {
        let memoize = _.memoize(function(input, search) {
            if (!input) return input;
            if (!search) return input;
            let expected = ('' + search).toLowerCase();
            let result = {};
            angular.forEach(input, function(value, key) {
                let someArr = [];
                //var someArr = value.concat([]);
                for (var i = 0, len = value.length; i < len; i++) {
                    let find = false;
                    angular.forEach(value[i], function(fieldValue, fieldName) {
                        let actual = ('' + fieldValue).toLowerCase();
                        if (actual.indexOf(expected) !== -1) {
                            find = true;
                            return;
                        }
                    });
                    if(find) {
                        someArr.push(value[i]);
                    }
                };
                if (someArr.length) {
                    result[key] = someArr;
                }
            });
            return result;
        }, function(input, search) {
            return input + search;
        });
        $rootScope.$on('clearFilterCache', function() {
            memoize.cache.clear();
        });

        return memoize;
    }])
    .filter('trustUrl', function($sce) {
        return function(url) {
            return $sce.trustAsResourceUrl(url);
        };
    })
    .filter('orderObjectBy', function() {
        return function(input, attribute) {
            if (!angular.isObject(input)) return input;

            var array = [];
            for (var objectKey in input) {
                array.push(input[objectKey]);
            }

            array.sort(function(a, b) {
                a = parseInt(a[attribute]);
                b = parseInt(b[attribute]);
                return a - b;
            });
            return array;
        }
    });